// γ-3-D refactor — extracted from LogisticsEditor.jsx (iter95c).
//
// Catalogue of every non-core ("side-panel") field plus the lookup helpers
// used by the editor's `LiveExtrasPanel` and the detail page's
// `AdditionalParametersPanel` safety net. Pure config — no JSX, no React.
//
// `group` = section in the right-side parameter panel.
// `type`  = controls the popover input (`text` / `number` / `date` /
//           `datetime` / `bool` / `select` / `csv` / `textarea` / `colleague`).
// `options` is only used when `type === 'select'`.

export const PARAMS = [
  { k: "azonosito", label: "Azonosító", group: "Identification", type: "text" },
  { k: "ajanlat_jellege", label: "Ajánlat jellege", group: "Identification", type: "text" },
  { k: "ajanlati_szint", label: "Ajánlati szint", group: "Identification", type: "select", options: ["initial", "revised", "final"] },
  { k: "forgalom_iranya", label: "Forgalom iránya", group: "Identification", type: "select", options: ["import", "export", "domestic", "cross_trade"] },
  { k: "is_tender", label: "Tender", group: "Identification", type: "bool" },
  { k: "ajanlat_ervenyessege", label: "Ajánlat érvényessége", group: "Identification", type: "date" },

  { k: "adr", label: "ADR", group: "Cargo", type: "bool" },
  { k: "un_szam", label: "UN szám", group: "Cargo", type: "text" },
  { k: "rakatolas_modja", label: "Rakatolás módja", group: "Cargo", type: "text" },
  { k: "hutes_hofok", label: "Hűtés / temperálás (°C)", group: "Cargo", type: "number" },
  { k: "kiegeszito_szolgaltatasok", label: "Kiegészítő szolgáltatások (CSV)", group: "Cargo", type: "csv" },

  { k: "celar", label: "Célár", group: "Pricing", type: "number" },
  { k: "ajanlati_margin_pct", label: "Ajánlati margin %", group: "Pricing", type: "number" },
  { k: "elfogadott_dij", label: "Elfogadott díj", group: "Pricing", type: "number" },
  { k: "fuvarozas_dij", label: "Fuvarozás díj", group: "Pricing", type: "number" },
  { k: "fuvarozas_koltseg", label: "Fuvarozás költség", group: "Pricing", type: "number" },
  { k: "fuvarozas_margin", label: "Fuvarozás margin", group: "Pricing", type: "number" },
  { k: "szallitmanyozas_dij", label: "Szállítmányozás díj", group: "Pricing", type: "number" },
  { k: "szallitmanyozas_koltseg", label: "Szállítmányozás költség", group: "Pricing", type: "number" },
  { k: "szallitmanyozas_margin", label: "Szállítmányozás margin", group: "Pricing", type: "number" },
  { k: "added_value_dij", label: "Added value díj", group: "Pricing", type: "number" },
  { k: "added_value_koltseg", label: "Added value költség", group: "Pricing", type: "number" },
  { k: "added_value_margin", label: "Added value margin", group: "Pricing", type: "number" },
  { k: "konkurencia_dij", label: "Konkurencia díj", group: "Pricing", type: "number" },
  { k: "amount", label: "Amount (deal value)", group: "Pricing", type: "number" },

  { k: "felelos_user_id", label: "Felelős (Person)", group: "Assignment", type: "colleague" },
  { k: "deal_tulajdonos_user_id", label: "Deal tulajdonos (Person)", group: "Assignment", type: "colleague" },
  { k: "ugyfelszolgalat_user_id", label: "Ügyfélszolgálati munkatárs (Person)", group: "Assignment", type: "colleague" },
  { k: "arazo_user_id", label: "Árazó szállítmányozó (Person)", group: "Assignment", type: "colleague" },
  { k: "external_forwarder_name", label: "Külső szállítmányozó (text)", group: "Assignment", type: "text" },

  { k: "arazasra_kikuldve_at", label: "Árazásra kiküldve", group: "Dates", type: "datetime" },
  { k: "kezdesi_datum", label: "Kezdési dátum", group: "Dates", type: "date" },
  { k: "projekt_kezdete", label: "Projekt kezdete", group: "Dates", type: "date" },

  { k: "szerzodes_idotartama_months", label: "Szerződés időtartama (hó)", group: "Tender", type: "number" },
  { k: "tender_atfutasi_napok", label: "Tender átfutási ideje (napok)", group: "Tender", type: "number" },
  { k: "kovetkezo_tender_date", label: "Következő tender", group: "Tender", type: "date" },
  { k: "tender_feltoltes_at", label: "Tender feltöltés időpont", group: "Tender", type: "datetime" },
  { k: "tender_kikuldes_at", label: "Tender kiküldés időpont", group: "Tender", type: "datetime" },
  { k: "tender_visszaigazolas_filename", label: "Tender visszaigazolás (file ref)", group: "Tender", type: "text" },

  { k: "bejovo_dokumentumok", label: "Bejövő dokumentumok (CSV)", group: "Documents", type: "csv" },
  { k: "kikuldott_dokumentumok", label: "Kiküldött dokumentumok (CSV)", group: "Documents", type: "csv" },

  { k: "kiegeszito_info", label: "Kiegészítő információk", group: "Notes", type: "textarea" },
  { k: "szakmai_kifogas", label: "Szakmai kifogás", group: "Notes", type: "textarea" },
  { k: "closed_reason", label: "Closed Won/Lost reason", group: "Notes", type: "textarea" },

  // γ-3-G — Megvalósult (Executed) post-execution tracking.
  // STRICT: Delay = CARRIER FAULT, KPI, minutes, settable ONLY in stage=executed.
  //         Waiting = SITE FAULT, surcharge (via "waiting" master entry).
  //         Never merge the two. Frontend enforces (read-only outside `executed`).
  { k: "delay_minutes", label: "Delay (carrier-fault, min)", group: "Execution", type: "number", executedOnly: true },
  { k: "delay_notes", label: "Delay reason / context", group: "Execution", type: "textarea", executedOnly: true },
  { k: "executed_notes", label: "Execution debrief notes", group: "Execution", type: "textarea", executedOnly: true },

  // G.1 — Commercial: Incoterms 2020 + named place. Editable at any stage.
  { k: "incoterm", label: "Incoterm (2020)", group: "Identification", type: "select",
    options: ["", "EXW", "FCA", "FAS", "FOB", "CFR", "CIF", "CPT", "CIP", "DAP", "DPU", "DDP"] },
  { k: "incoterm_named_place", label: "Incoterm named place", group: "Identification", type: "text" },

  // G.3a — Container / multimodal flags. Editable at any stage.
  { k: "is_container_movement", label: "Container movement", group: "Identification", type: "bool" },
  { k: "transport_modes", label: "Transport modes (csv)", group: "Identification", type: "csv",
    help: "Comma-separated: road, sea, rail, air, multimodal." },

  // G.3b — Container ports (POL / POD). Customer-visible operational facts.
  // Object shape: {un_locode?, name?, country?}.
  { k: "port_of_loading", label: "Port of loading (POL)", group: "Identification", type: "json",
    placeholder: '{"un_locode":"DEHAM","name":"Hamburg","country":"DE"}' },
  { k: "port_of_discharge", label: "Port of discharge (POD)", group: "Identification", type: "json",
    placeholder: '{"un_locode":"HUBUD","name":"Budapest","country":"HU"}' },

  // G.3c — Pre-carriage (előfutás: road into POL) + on-carriage (utófutás:
  // road out of POD). Forwarder-internal ops; customer tier strips these.
  // Object shape: {mode, pickup_location?, dropoff_location?, carrier_name?,
  //   vehicle_plate?, status?, cost_amount?, cost_currency?, notes?}.
  { k: "pre_carriage", label: "Pre-carriage (előfutás)", group: "Identification", type: "json",
    placeholder: '{"mode":"road","carrier_name":"...","vehicle_plate":"...","cost_amount":0,"cost_currency":"EUR"}' },
  { k: "on_carriage", label: "On-carriage (utófutás)", group: "Identification", type: "json",
    placeholder: '{"mode":"road","carrier_name":"...","vehicle_plate":"...","cost_amount":0,"cost_currency":"EUR"}' },

  // G.3d — Intermodal connection points: list of handover events between
  // modes. Customer-visible.
  // Each entry shape: {location, country?, from_mode, to_mode, handover_at?, notes?}.
  { k: "intermodal_connection_points", label: "Intermodal points", group: "Identification", type: "json",
    placeholder: '[{"location":"Hamburg port","from_mode":"road","to_mode":"sea"}]' },

  // G.1 — Execution group: "Who & What executes this freight". Executed-stage only.
  { k: "vehicle_provider", label: "Vehicle provider", group: "Execution", type: "select",
    options: ["", "own", "subcontractor"], executedOnly: true },
  { k: "subcontractor_name", label: "Subcontractor name", group: "Execution", type: "text", executedOnly: true },
  { k: "vehicle_plate", label: "Vehicle plate", group: "Execution", type: "text", executedOnly: true },
  { k: "trailer_plate", label: "Trailer plate", group: "Execution", type: "text", executedOnly: true },
  { k: "driver_name", label: "Driver name", group: "Execution", type: "text", executedOnly: true },
];

export const PARAM_GROUPS = ["Identification", "Cargo", "Pricing", "Assignment", "Dates", "Tender", "Documents", "Notes", "Execution"];

// γ-3-H follow-up — Self-explanatory short labels + tooltip-grade full
// localized names for the CompletenessMeter sparkline. The previous 3-letter
// slice (Ide/Car/Pri/Ass/Dat/Ten/Doc/Not/Exe) was unreadable ("Car" looked
// like the vehicle, "Ass" was awkward). Short labels fit the 360px-wide
// side panel; full names appear on hover.
export const PARAM_GROUP_SHORT = {
  Identification: "ID",
  Cargo: "Cargo",
  Pricing: "Price",
  Assignment: "Team",
  Dates: "Dates",
  Tender: "Tender",
  Documents: "Docs",
  Notes: "Notes",
  Execution: "Exec",
};

export const PARAM_GROUP_LABELS_I18N = {
  en: {
    Identification: "Identification",
    Cargo: "Cargo",
    Pricing: "Pricing",
    Assignment: "Assignment",
    Dates: "Dates",
    Tender: "Tender",
    Documents: "Documents",
    Notes: "Notes",
    Execution: "Execution",
  },
  de: {
    Identification: "Identifikation",
    Cargo: "Fracht",
    Pricing: "Preisgestaltung",
    Assignment: "Zuweisung",
    Dates: "Termine",
    Tender: "Ausschreibung",
    Documents: "Dokumente",
    Notes: "Notizen",
    Execution: "Durchführung",
  },
  hu: {
    Identification: "Azonosítás",
    Cargo: "Áru",
    Pricing: "Árazás",
    Assignment: "Felelősök",
    Dates: "Dátumok",
    Tender: "Tender",
    Documents: "Dokumentumok",
    Notes: "Megjegyzések",
    Execution: "Megvalósulás",
  },
};

export const PARAM_BY_KEY = Object.fromEntries(PARAMS.map((p) => [p.k, p]));

export const isFilled = (v) => {
  if (v == null || v === "") return false;
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === "object") return Object.keys(v).length > 0;
  return true;
};

// Total count used for completeness meters.
export const PARAM_TOTAL = PARAMS.length;
